/*
 * Copyright 2024, Corning Optical Communications
 * All Rights Reserved.
 */

import React from "react";
import { Checkbox } from "@mui/material";
import { AlarmDefinition } from "../types";
import { isBitSet, getAlarmLedColor } from "../utils";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../ui/table";

interface AlarmTableProps {
  alarms: any;
  alarmsMask: any;
  alarmDefinitions: AlarmDefinition[];
  isDisconnected: boolean;
}

const AlarmTable: React.FC<AlarmTableProps> = ({
  alarms,
  alarmsMask,
  alarmDefinitions,
  isDisconnected,
}) => {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead className="w-14 text-center">Status</TableHead>
          <TableHead>Alarm Name</TableHead>
          <TableHead className="w-24 text-center">Enabled</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {alarmDefinitions.map((alarm) => {
          const isAlarmActive = isBitSet(alarms, alarm.bit);
          const isMaskEnabled = isBitSet(alarmsMask, alarm.bit);

          return (
            <TableRow key={alarm.bit}>
              <TableCell className="text-center">
                <div
                  className="w-3 h-3 rounded-full mx-auto"
                  style={{ backgroundColor: getAlarmLedColor(isDisconnected, isAlarmActive) }}
                />
              </TableCell>
              <TableCell>{alarm.name}</TableCell>
              <TableCell className="text-center">
                <Checkbox
                  checked={isMaskEnabled}
                  disabled
                  size="small"
                  sx={{
                    padding: 0,
                    color: "var(--foreground)",
                    "&.Mui-disabled": { color: "var(--muted-foreground)" },
                  }}
                />
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};

export default AlarmTable;
